import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { Login } from './Login'

export const LoginModal = ({
  loginUrl,
  passwordResetUrl,
  registrationUrl,
  csrfTokens,
  labels,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [title, setTitle] = useState(labels.title)

  useEffect(() => {
    const openModal = ({ detail }) => {
      setTitle(detail?.title || labels.title)
      setIsOpen(true)
    }
    const openModalFromTrigger = (event) => {
      const trigger = event.target.closest('[data-login-modal-open]')

      if (!trigger) {
        return
      }

      event.preventDefault()
      openModal({
        detail: {
          title: trigger.dataset.loginModalTitle,
        },
      })
    }

    document.addEventListener('login-modal:open', openModal)
    document.addEventListener('click', openModalFromTrigger)

    return () => {
      document.removeEventListener('login-modal:open', openModal)
      document.removeEventListener('click', openModalFromTrigger)
    }
  }, [labels.title])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="login-modal"
      overlayClassName="login-modal-overlay"
      contentLabel={title}
    >
      <button
        type="button"
        className="login-modal__close"
        onClick={() => setIsOpen(false)}
        aria-label={labels.close}
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.9693 1.49892L1.64335 21.8249L0.144531 20.326L20.4705 0.000100711L21.9693 1.49892Z"
            fill="#171717"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.0064 4.5359L4.68046 24.8619L3.18164 23.363L23.5076 3.03709L25.0064 4.5359Z"
            fill="#171717"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.53615 -5.71147e-05L24.8621 20.3259L23.3633 21.8247L3.03733 1.49876L4.53615 -5.71147e-05Z"
            fill="#171717"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.49904 3.0373L21.825 23.3632L20.3262 24.8621L0.000222781 4.53611L1.49904 3.0373Z"
            fill="#171717"
          />
        </svg>
      </button>
      <Login
        csrfTokens={csrfTokens}
        labels={labels}
        loginUrl={loginUrl}
        passwordResetUrl={passwordResetUrl}
        registrationUrl={registrationUrl}
        title={title}
      />
    </Modal>
  )
}
